export const QUIZ_WRITER_CARD_BACKGROUND_GRADIENT =
  "linear-gradient(135deg, hsl(197 100% 37%) 0%, hsl(122 39% 49%) 100%)";

/** Visible steps on the generating UI; step 10 completes when quiz content arrives. */
export const QUIZ_GENERATION_TOTAL_STEPS = 10;

/** After this many `user_log` messages, hold the bar until `result` (final content). */
export const QUIZ_GENERATION_PROGRESS_CAP = 9;

/** Same path as QUIZ_WRITER_AGENT_WS_PATH on the website server. */
export const QUIZ_WRITER_WS_PATH = "/sockets/quiz-writer";

/** Same path as QUIZ_WRITER_TOPIC_GENERATOR_WS_PATH in quizWriterAgentRoutes. */
export const QUIZ_TOPIC_GENERATOR_WS_PATH =
  "/sockets/quiz-writer-topic-generator";
